import { ApolloError, ServerError, ServerParseError } from "@apollo/client";
import { Link } from "react-router-dom";

import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  root: {
    margin: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  card: {
    maxWidth: "600px",
    width: "80%"
  }
}));

const checkServerError = (
  checkServerErrorTest: any,
  networkError?: Error | ServerError | ServerParseError | null
): networkError is ServerError =>
  checkServerErrorTest(networkError as ServerError);

const withStatusCode = (error: ApolloError, statusCode: number): boolean =>
  checkServerError(
    (serverError: ServerError | null): boolean =>
      serverError?.statusCode === statusCode,
    error.networkError
  );

const friendlyMessage = (error: ApolloError): string => {
  if (withStatusCode(error, 500)) {
    return "Application error - Scale To Win support staff have been notified.";
  } else if (error.networkError?.message === "Failed to fetch") {
    return "Network error - please check your internet connection and try again.";
  }
  return error.message;
};

export default function ErrorCard({
  errors
}: {
  errors: Array<any>;
}): JSX.Element {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardHeader title="Encountered errors" />
        <CardContent>
          {errors.map((err, index) => (
            <p key={index}>{friendlyMessage(err)}</p>
          ))}
          <p>
            Seeing this a lot?{" "}
            <a
              href="https://scaletowin.freshdesk.com/support/tickets/new"
              target="_blank"
              rel="noopener noreferer"
            >
              Send us a support ticket.
            </a>
          </p>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
          <Link component={Button} to="/admin">
            Go Home
          </Link>
        </CardActions>
      </Card>
    </div>
  );
}
